// Expose a basic orthographic camera to use for postpro with bigTriangle

import { OrthographicCamera } from 'three'

export default new OrthographicCamera( -1, 1, 1, -1, 0, 1 )
